import React, { createContext, useContext, useState, useEffect } from 'react';

// Translations
const translations = {
    ro: {
        // Navbar
        home: "Acasă",
        conversations: "Conversații",
        exercises: "Exerciții",
        journal: "Jurnal",
        addCredits: "Adaugă credite",
        
        // Home page
        consciousHuman: "Conștiință umană lucidă",
        heroTitle1: "Ghidul tău pentru",
        heroTitle2: "educație",
        heroTitle3: ",",
        heroTitle4: "autocunoaștere",
        heroTitle5: "și",
        heroTitle6: "trezire interioară",
        heroDescription: "Bazat pe metodologia Triboi, Iulian AI te ajută să navighezi prin traume, provocări educaționale și emoții dificile cu prezență și claritate.",
        startConversation: "Începe o conversație",
        exploreExercises: "Explorează exercițiile",
        presence: "Prezență",
        beHereNow: "Fii aici. Fii acum.",
        chooseYourPath: "Alege-ți calea",
        conversationAdapted: "Fiecare conversație este adaptată nevoilor tale specifice",
        startConvo: "Începe conversația",
        
        // Categories
        traume: "Traume non-clinice",
        traumeDesc: "Ghidare pentru procesarea experiențelor dificile",
        educatie: "Educație",
        educatieDesc: "Suport pentru dificultăți de învățare și dezvoltare",
        emotii: "Emoții",
        emotiiDesc: "Tehnici pentru gestionarea emoțiilor",
        
        // Interactions section
        interactions: "INTERACȚIUNI",
        aiConversations: "Conversații AI",
        aiConversationsDesc: "Ghidare empatică bazată pe metodologia Triboi",
        personalJournal: "Jurnal Personal",
        personalJournalDesc: "Spațiu privat pentru reflecții și gânduri",
        practicalExercises: "Exerciții Practice",
        practicalExercisesDesc: "Tehnici validate pentru reglare emoțională",
        confidentiality: "Confidențialitate",
        confidentialityDesc: "Datele tale rămân în siguranță",
        
        // CTA
        readyToStart: "Ești gata să începi călătoria?",
        everyStepCounts: "Fiecare pas contează. Vindecarea este un proces, nu o destinație.",
        startNow: "Începe acum",
        
        // Footer
        footerText: "Iulian AI • Bazat pe metodologia Triboi • Pentru suport non-clinic",
        footerAiDisclaimer: "Iulian AI poate să greșească. Verifică informațiile importante.",
        footerWarning: "Pentru orice simptome fizice sau emoționale severe, consultați un medic sau specialist.",
        
        // Pricing
        pricingTitle: "Alege planul potrivit pentru tine",
        pricingSubtitle: "Codurile primite pe email pot fi folosite simultan pe mai multe dispozitive",
        responses: "răspunsuri",
        month: "lună",
        months: "luni",
        year: "an",
        validity: "Valabilitate",
        costPerResponse: "Cost/răspuns",
        getAccess: "Obține acces",
        popular: "POPULAR",
        planStart: "START",
        planStandard: "STANDARD",
        planPlus: "PLUS",
        planPro: "PRO",
        
        // Chat page
        whatToTalkAbout: "Despre ce vrei să vorbim?",
        chooseCategory: "Alege o categorie pentru a începe o conversație personalizată",
        recentConversations: "Conversații recente",
        newConversation: "Conversație nouă",
        welcomeToSpace: "Bun venit în spațiul",
        writeYourConcern: "Scrie ce te preocupă și voi fi aici să te ghidez cu prezență și claritate.",
        writeYourMessage: "Scrie mesajul tău...",
        listen: "Ascultă",
        pause: "Pauză",
        continue: "Continuă",
        loading: "Se încarcă...",
        
        // Exercises page
        practicalExercisesTitle: "Exerciții Practice",
        exercisesDescription: "Tehnici validate pentru reglare emoțională, gestiunea traumelor și dezvoltare personală",
        all: "Toate",
        stepsToFollow: "Pași de urmat",
        backToExercises: "Înapoi la exerciții",
        start: "Începe",
        congratulations: "Felicitări!",
        completedAllSteps: "Ai completat toate pașii exercițiului. Cum te simți?",
        
        // Journal page
        yourJournal: "Jurnalul Tău",
        journalDescription: "Un spațiu privat pentru gânduri, reflecții și descoperiri personale",
        newNote: "Notă nouă",
        journalEmpty: "Jurnalul tău este gol",
        startWriting: "Începe să-ți notezi gândurile și reflecțiile",
        backToJournal: "Înapoi la jurnal",
        edit: "Editează",
        title: "Titlu",
        titlePlaceholder: "Titlul notei...",
        content: "Conținut",
        contentPlaceholder: "Scrie-ți gândurile aici...",
        howDoYouFeel: "Cum te simți?",
        tags: "Etichete",
        addTagPlaceholder: "Scrie o etichetă și apasă Enter...",
        cancel: "Anulează",
        save: "Salvează",
        saving: "Se salvează...",
        
        // Moods
        calm: "Calm",
        happy: "Fericit",
        neutral: "Neutru",
        anxious: "Anxios",
        sad: "Trist",
        
        // Alerts & Confirmations
        fillTitleContent: "Te rog completează titlul și conținutul!",
        errorSaving: "Eroare la salvare. Încearcă din nou.",
        errorUpdating: "Eroare la actualizare. Încearcă din nou.",
        confirmDelete: "Ești sigur că vrei să ștergi această notă?",
        confirmDeleteConversation: "Ești sigur că vrei să ștergi această conversație?",
        
        // Delete button
        delete: "Șterge",
        
        // Disclaimer
        disclaimerTitle: "AVERTISMENT MEDICAL ȘI PSIHOLOGIC CRITIC",
        disclaimerText1: "Iulian AI este un instrument de antrenament educațional, NU un serviciu medical, psihiatric sau psihologic.",
        disclaimerText2: "NU diagnostichează și NU tratează PTSD, Depresie sau orice altă tulburare clinică.",
        disclaimerCrisis: "ÎN CRIZĂ? Sună 112 (EU/RO) sau 911 (US) imediat.",
        findHelpline: "Găsește o linie de ajutor în țara ta (Click Aici)",
        
        // Access Code
        enterAccessCode: "INTRODU CODUL DE ACCES",
        accessCodePlaceholder: "Introduceți codul primit prin email",
        activate: "Activează",
        questionsRemaining: "întrebări rămase",
        codeActivated: "Cod activat!",
        invalidCode: "Cod invalid",
        noQuestionsLeft: "Nu mai ai întrebări disponibile",
        enterCodeFirst: "Introdu codul de acces pentru a pune întrebări",
        
        // Terms & Conditions
        termsAndConditions: "Termeni și Condiții",
        privacyPolicy: "Politica de Confidențialitate",
        openTermsToEnable: "Deschide Termeni & Condiții pentru a activa...",
        iAgreeToTerms: "Am citit și accept Termenii și Condițiile",
        readAndAgree: "AM CITIT ȘI ACCEPT TERMENII",
        agreeAndFinalize: "ACCEPT ȘI FINALIZEZ",
        termsRequired: "Trebuie să accepți termenii pentru a continua",
        
        // Multilingual Support
        multilingualSupport: "Suport Multilingv",
        multilingualTitle: "Suport Multilingv (Folosește Traducerea Browser-ului)",
        multilingualMessage: "Click dreapta oriunde pe pagină și selectează \"Traduce în [Limba]\" pentru a vizualiza în limba ta.\n\nPe mobil, apasă pe iconița (AA) sau (⋮) din meniul browser-ului.",
        ok: "OK",
    },
    en: {
        // Navbar
        home: "Home",
        conversations: "Conversations",
        exercises: "Exercises",
        journal: "Journal",
        addCredits: "Add credits",
        
        // Home page
        consciousHuman: "Lucid human consciousness",
        heroTitle1: "Your guide for",
        heroTitle2: "education",
        heroTitle3: ",",
        heroTitle4: "self-knowledge",
        heroTitle5: "and",
        heroTitle6: "awakening",
        heroDescription: "Based on the Triboi methodology, Iulian AI helps you navigate through trauma, educational challenges and difficult emotions with presence and clarity.",
        startConversation: "Start a conversation",
        exploreExercises: "Explore exercises",
        presence: "Presence",
        beHereNow: "Be here. Be now.",
        chooseYourPath: "Choose your path",
        conversationAdapted: "Each conversation is adapted to your specific needs",
        startConvo: "Start conversation",
        
        // Categories
        traume: "Non-clinical Trauma",
        traumeDesc: "Guidance for processing difficult experiences",
        educatie: "Education",
        educatieDesc: "Support for learning difficulties and development",
        emotii: "Emotions",
        emotiiDesc: "Techniques for managing emotions",
        
        // Interactions section
        interactions: "INTERACTIONS",
        aiConversations: "AI Conversations",
        aiConversationsDesc: "Empathic guidance based on Triboi methodology",
        personalJournal: "Personal Journal",
        personalJournalDesc: "Private space for reflections and thoughts",
        practicalExercises: "Practical Exercises",
        practicalExercisesDesc: "Validated techniques for emotional regulation",
        confidentiality: "Confidentiality",
        confidentialityDesc: "Your data remains safe",
        
        // CTA
        readyToStart: "Ready to start the journey?",
        everyStepCounts: "Every step counts. Healing is a process, not a destination.",
        startNow: "Start now",
        
        // Footer
        footerText: "Iulian AI • Based on Triboi methodology • For non-clinical support",
        footerAiDisclaimer: "Iulian AI can make mistakes. Verify important information.",
        footerWarning: "For any severe physical or emotional symptoms, consult a doctor or specialist.",
        
        // Pricing
        pricingTitle: "Choose the right plan for you",
        pricingSubtitle: "Codes received by email can be used simultaneously on multiple devices",
        responses: "responses",
        month: "month",
        months: "months",
        year: "year",
        validity: "Validity",
        costPerResponse: "Cost/response",
        getAccess: "Get Access",
        popular: "POPULAR",
        planStart: "START",
        planStandard: "STANDARD",
        planPlus: "PLUS",
        planPro: "PRO",
        
        // Chat page
        whatToTalkAbout: "What would you like to talk about?",
        chooseCategory: "Choose a category to start a personalized conversation",
        recentConversations: "Recent conversations",
        newConversation: "New conversation",
        welcomeToSpace: "Welcome to the",
        writeYourConcern: "Write what concerns you and I'll be here to guide you with presence and clarity.",
        writeYourMessage: "Write your message...",
        listen: "Listen",
        pause: "Pause",
        continue: "Continue",
        loading: "Loading...",
        
        // Exercises page
        practicalExercisesTitle: "Practical Exercises",
        exercisesDescription: "Validated techniques for emotional regulation, trauma management and personal development",
        all: "All",
        stepsToFollow: "Steps to follow",
        backToExercises: "Back to exercises",
        start: "Start",
        congratulations: "Congratulations!",
        completedAllSteps: "You have completed all the exercise steps. How do you feel?",
        
        // Journal page
        yourJournal: "Your Journal",
        journalDescription: "A private space for thoughts, reflections and personal discoveries",
        newNote: "New note",
        journalEmpty: "Your journal is empty",
        startWriting: "Start writing down your thoughts and reflections",
        backToJournal: "Back to journal",
        edit: "Edit",
        title: "Title",
        titlePlaceholder: "Note title...",
        content: "Content",
        contentPlaceholder: "Write your thoughts here...",
        howDoYouFeel: "How do you feel?",
        tags: "Tags",
        addTagPlaceholder: "Write a tag and press Enter...",
        cancel: "Cancel",
        save: "Save",
        saving: "Saving...",
        
        // Moods
        calm: "Calm",
        happy: "Happy",
        neutral: "Neutral",
        anxious: "Anxious",
        sad: "Sad",
        
        // Alerts & Confirmations
        fillTitleContent: "Please fill in the title and content!",
        errorSaving: "Error saving. Please try again.",
        errorUpdating: "Error updating. Please try again.",
        confirmDelete: "Are you sure you want to delete this note?",
        confirmDeleteConversation: "Are you sure you want to delete this conversation?",
        
        // Delete button
        delete: "Delete",
        
        // Disclaimer
        disclaimerTitle: "CRITICAL MEDICAL & PSYCHOLOGICAL DISCLAIMER",
        disclaimerText1: "Iulian AI is an educational training tool, NOT a medical, psychiatric, or psychological service.",
        disclaimerText2: "It does NOT diagnose or treat PTSD, Depression, or any clinical disorder.",
        disclaimerCrisis: "IN CRISIS? Call 911 (US) or 112 (EU/UK) immediately.",
        findHelpline: "Find a local helpline worldwide (Click Here)",
        
        // Access Code
        enterAccessCode: "ENTER ACCESS CODE",
        accessCodePlaceholder: "Enter code received by email",
        activate: "Activate",
        questionsRemaining: "questions remaining",
        codeActivated: "Code activated!",
        invalidCode: "Invalid code",
        noQuestionsLeft: "No questions remaining",
        enterCodeFirst: "Enter access code to ask questions",
        
        // Terms & Conditions
        termsAndConditions: "Terms & Conditions",
        privacyPolicy: "Privacy Policy",
        openTermsToEnable: "Open Terms & Privacy to enable...",
        iAgreeToTerms: "I have read and agree to the Terms & Conditions",
        readAndAgree: "I READ AND AGREE TO TERMS",
        agreeAndFinalize: "I AGREE & FINALIZE",
        termsRequired: "You must accept the terms to continue",
        
        // Multilingual Support
        multilingualSupport: "Multilingual Support",
        multilingualTitle: "Multilingual Support (Use Browser Translate)",
        multilingualMessage: "Right-click anywhere on the page and select \"Translate to [Language]\" to view in your native tongue.\n\nOn mobile, tap the (AA) or (⋮) icon in your browser menu.",
        ok: "OK",
    }
};

// Context
const LanguageContext = createContext();

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState(() => {
        // Get from localStorage or default to English for international SEO
        const saved = localStorage.getItem('iulian_ai_language');
        return saved || 'en';
    });

    useEffect(() => {
        localStorage.setItem('iulian_ai_language', language);
    }, [language]);

    const toggleLanguage = () => {
        setLanguage(prev => prev === 'ro' ? 'en' : 'ro');
    };

    const t = (key) => {
        return translations[language][key] || key;
    };

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
}

export default LanguageContext;
